// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c30v1a from './c30v1a'; // 団体情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i14v1a from './i14v1a'; // 設定情報

import c51v1a from './c51v1a';

import cView from './cView';

import myPD from './myPD_20211208';

import i11v from './i11v_20211024';
import i15v from './i15v_20211024';
import i1zv from './i1zv_20211024';

import myWB from './myWB_20211212';
import myXL from './myXL_20211211';

let _b_endNew = false;

//export default class i1zv1 extends cView { // 設備予約　管理用用画面
export default class i1zv1 extends i1zv { // 設備予約　管理用用画面

/*
constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}
*/

// $opb_chk, render は個別に実装

/*
_eptExl1 = async () => {

  const _o_this = this;

  cf.s();

  let _mth = ff.myDT_cnv('fdm', _o_this.state.s_i1zri21dStt).substr(0,7);

  const _ld_shtss= [];

  let _sht = `室(${_mth})`;

  let _ld_hdrss = [
    { key:  1, header: '時間帯区分', width: 20, style: {} },
    { key:  2, header: '室', width: 20, style: {}  },
    { key:  3, header: '集計対象', width: 20, style: {}  },
    { key:  4, header: '時間帯', width: 20, style: {}  },
    { key:  5, header: _mth, width: 20, style: {}  },
  ];

  let _ld_bdyss = [];

  let _dddd_bdyssss = { '時間帯区分合計': { '室合計': { '申請数': 0 }} };

  i11v.op_loadList({
    elm: 'i11r',
    dd_cldDefss: {
      i10r: {
        elm: 'i10r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('i10r', `i10rb51f = ${_dd_datss.i11r.d_flds._fst} AND i10rt11i = 200`)
          return _cnd;
        },
        dd_cldDefss: {
          i1zr: {
            elm: 'i1zr',
            o_cnd: _dd_datss => {
//              let _cnd = cf.c('i1zr', `i1zrb41f = ${_dd_datss.i10r.d_flds._fst} AND i1zri21d LIKE "${_mth}%" AND i1zrs11i = 90 `);
              let _cnd = cf.c('c30r', `t_c30r.c30rc31s LIKE "予約不可%"`);
              _cnd = cf.c('i1zr', `i1zrb41f = ${_dd_datss.i10r.d_flds._fst} AND i1zri21d LIKE "${_mth}%" AND i1zrs11i = 90 AND i1zrb31f NOT IN (SELECT _fst FROM t_c30r WHERE ${_cnd})`);
//ff.l('i1zv1 85: {}'.f(_cnd));
              return _cnd;
            },

            dd_cldDefss: {
              i1z0: {
                elm: 'i1z0',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
                  return _cnd;
                },
                dd_rfrss: {
                  i110: {
                    elm: 'i110',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c('i110', `t_i110._fst = (${_d_flds.i1z0b51f})`);
                      return _cnd;
                    },
                  },
                },
              },
            },

          },
        },
      },
      i110: {
        elm: 'i110',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('i110', `i110b51k = ${_dd_datss.i11r.d_flds._key}`)
          return _cnd;
        }
      }
    },
  })
  .then(() => {

    _o_this.state.sdld_i11rListsss.i11r.map( _d_i11rs => {
      let _i11rc31s = _d_i11rs.d_flds.i11rc31s ?? ''; // 時間帯区分
      if (!_dddd_bdyssss[_i11rc31s]) _dddd_bdyssss[_i11rc31s] = { '室合計': { 'コマ数': {}, '申請数': 0 } };
      if (!_dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']) _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'] = 0;
      if (_d_i11rs.dld_cldDatsss.i10r.length > 0) {

        _d_i11rs.dld_cldDatsss.i10r.map( _d_i10rs => {
          let _i10rc31s = _d_i10rs.d_flds.i10rc31s ?? ''; // 室
          if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]) _dddd_bdyssss[_i11rc31s][_i10rc31s] = { 'コマ数': {}, '申請数': 0 };
          if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']) _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'] = 0;
          if (_d_i10rs.dld_cldDatsss.i1zr.length > 0) {
            _d_i10rs.dld_cldDatsss.i1zr.map( _d_i1zrs => {            
              _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数'] += 1;
              _dddd_bdyssss[_i11rc31s]['室合計']['申請数'] += 1;
              _dddd_bdyssss['時間帯区分合計']['室合計']['申請数'] += 1;

              _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {
                let _i110c31s = _d_i110s.d_flds.i110c31s ?? ''; // 予約情報
                if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]) _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s] = 0;
                if (!_dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]) _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s] = 0;
                if (_d_i1zrs.dld_cldDatsss.i1z0.length > 0) {
                  _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {
                    if ( _d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                      _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s] += 1;
                      _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'] += 1;
                      _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s] += 1;
                      _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'] += 1;
                    };
                  });
                };
              });
            });

            _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {
              let _i110c31s = _d_i110s.d_flds.i110c31s ?? ''; // 予約情報
              _ld_bdyss.push({
                1: _i11rc31s,
                2: _i10rc31s,
                3: 'コマ数',
                4: _i110c31s,
                5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s] ?? 0,
              });
            });

            _ld_bdyss.push({
              1: _i11rc31s,
              2: _i10rc31s,
              3: 'コマ数',
              4: '時間帯合計',
              5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'] ?? 0,
            });

            _ld_bdyss.push({
              1: _i11rc31s,
              2: _i10rc31s,
              3: '申請数',
              4: '',
              5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数'] ?? 0,
            });

          };
        
        });

        if (_d_i11rs.dld_cldDatsss.i110.length > 0) {
          _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {
            let _i110c31s = _d_i110s.d_flds.i110c31s ?? '';
            _ld_bdyss.push({
              1: _i11rc31s,
              2: '室合計',
              3: 'コマ数',
              4: _i110c31s,
              5: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s] ?? 0,
            });
          });

          _ld_bdyss.push({
            1: _i11rc31s,
            2: '室合計',
            3: 'コマ数',
            4: '時間帯合計',
            5: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'] ?? 0,
          });

          _ld_bdyss.push({
            1: _i11rc31s,
            2: '室合計',
            3: '申請数',
            4: '',
            5: _dddd_bdyssss[_i11rc31s]['室合計']['申請数'] ?? 0,
          });
        };
      };
    });

    _ld_bdyss.push({
      1: '時間帯区分合計',
      2: '室合計',
      3: '申請数',
      4: '',
      5: _dddd_bdyssss['時間帯区分合計']['室合計']['申請数'] ?? 0,
    });

    _ld_shtss.push({
      sht: _sht,
      ld_hdrss: _ld_hdrss,
      ld_bdyss: _ld_bdyss,
    });

    _sht = `団体種別(${_mth})`;

    _ld_hdrss = [
      { key:  1, header: '団体種別', width: 20, style: {} },
      { key:  2, header: '集計対象', width: 20, style: {}  },
      { key:  3, header: _mth, width: 20, style: {}  },
    ];

    _ld_bdyss = [];

    i15v.op_loadList({
      elm: 'i15r',
      dd_cldDefss: {
        c30r: {
          elm: 'c30r',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('c30r', `t_c30r.c30rbk1f = ${_dd_datss.i15r.d_flds._fst}`);
            return _cnd;
          },
          dd_cldDefss: {
            i1zr: {
              elm: 'i1zr',
              o_cnd: _dd_datss => {
                let _cnd = cf.c('i1zr', `i1zrb31f = ${_dd_datss.c30r.d_flds._fst} AND i1zri21d LIKE "${_mth}%" AND i1zrs11i = 90`);
                return _cnd;
              },
              dd_cldDefss: {
                i1z0: {
                  elm: 'i1z0',
                  o_cnd: _dd_datss => {
                    let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
                    return _cnd;
                  },
                  dd_rfrss: {
                    i110: {
                      elm: 'i110',
                      o_cnd: _d_flds => {
                        let _cnd = cf.c('i110', `t_i110._fst = (${_d_flds.i1z0b51f})`);
                        return _cnd;
                      },
                    },
                  },
                },
              },

            },
          },
        }
      },
    })
    .then(() => {
  
      let _dd_Allbdyss = { '申請数': 0, 'コマ数': 0, '人数': 0,  };
      _o_this.state.sdld_i15rListsss.i15r.map( _d_i15rs => {
        let _i15rc31s = _d_i15rs.d_flds.i15rc31s;
        let _dd_bdyss = { '申請数': 0, 'コマ数': 0, '人数': 0,  };
        if (_d_i15rs.dld_cldDatsss?.c30r?.length > 0) {
          _d_i15rs.dld_cldDatsss.c30r.map( _d_c30rs => {
            if (_d_c30rs.dld_cldDatsss?.i1zr?.length > 0) {
              _d_c30rs.dld_cldDatsss.i1zr.map( _d_i1zrs => {
                _dd_bdyss['申請数'] += 1;
                _dd_bdyss['人数'] += ff.n(_d_i1zrs.d_flds.i1zri41i);
                _dd_Allbdyss['申請数'] += 1;
                _dd_Allbdyss['人数'] += ff.n(_d_i1zrs.d_flds.i1zri41i);
                if (_d_i1zrs.dld_cldDatsss?.i1z0?.length > 0) {
                  _d_i1zrs.dld_cldDatsss.i1z0.map( _d_i1z0s => {
                    _dd_bdyss['コマ数'] += 1;
                    _dd_Allbdyss['コマ数'] += 1;
                  });
                };
              });
            };
          });
        };

        _ld_bdyss.push({
          1: _i15rc31s,
          2: '申請数',
          3: _dd_bdyss['申請数'],
        });

        _ld_bdyss.push({
          1: _i15rc31s,
          2: 'コマ数',
          3: _dd_bdyss['コマ数'],
        });

        _ld_bdyss.push({
          1: _i15rc31s,
          2: '人数',
          3: _dd_bdyss['人数'],
        });

      });

      _ld_bdyss.push({
        1: '団体種別合計',
        2: '申請数',
        3: _dd_Allbdyss['申請数'],
      });

      _ld_bdyss.push({
        1: '団体種別合計',
        2: 'コマ数',
        3: _dd_Allbdyss['コマ数'],
      });

      _ld_bdyss.push({
        1: '団体種別合計',
        2: '人数',
        3: _dd_Allbdyss['人数'],
      });

      _ld_shtss.push({
        sht: _sht,
        ld_hdrss: _ld_hdrss,
        ld_bdyss: _ld_bdyss,
      });

      myXL.myXL_dwlFile({
        n_ver: 2,
        file: `予約一覧_${ff.myDT_getDate('today').replace(/-/g, '')}.xlsx`,
        ld_shtss: _ld_shtss,
      })
      .then(() => {
        cf.h();
      });

    });

  });


};
*/

$opb_chk = (pb_msg=true) => new Promise( _o_end1 => { // 

  const _o_this = this;

  ff.myCM_srl([
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs11i == 20
        ) {
          if (pb_msg) alert(`予約がキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs21i == 20
        ) {
          if (pb_msg) alert(`エントリーがキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['show'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (
          _d_i1zrs.d_flds.i1zrs22i == 20
        ) {
          if (pb_msg) alert(`優先エントリーがキャンセル済のため、指定された操作を行うことができません`);
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => { // 直接予約は仮押があるため対象外
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1b', 'i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        //ff.l('1115: {}, {}, {}, {}, {}, {}, {}, {}'.f(
        //  ff.f(_d_i1zrs.d_flds.i1zri11s),
        //  ff.f(_d_i1zrs.d_flds.i1zri12s),
        //  ff.f(_d_i1zrs.d_flds.i1zri41s),
        //  ff.n(_d_i1zrs.d_flds.i1zri41i),
        //  ff.n(_d_i1zrs.d_flds.i1zrt41i),
        //  ff.n(_d_i1zrs.d_flds.i1zrb41f),
        //  ff.f(_d_i1zrs.d_flds.i1zri21d),
        //  ff.n(ff.myCM_getLen(_d_i1zrs.dld_cldDatsss.i1z0))
        //));
        if (
          ff.f(_d_i1zrs.d_flds.i1zri11s) == false ||
          ff.f(_d_i1zrs.d_flds.i1zri12s) == false ||
          ff.f(_d_i1zrs.d_flds.i1zri41s) == false ||
          ff.n(_d_i1zrs.d_flds.i1zri41i) < 1 ||
          ff.n(_d_i1zrs.d_flds.i1zrt41i) < 0 ||
          ff.n(_d_i1zrs.d_flds.i1zrb41f) < 1 ||
          ff.f(_d_i1zrs.d_flds.i1zri21d) == false ||
          ff.n(ff.myCM_getLen(_d_i1zrs.dld_cldDatsss.i1z0)) < 1
        ) {
          if (pb_msg) alert('入力されていない項目があるため、指定された操作を行うことができません');
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        // 室の確認
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
        if (
          ff.i(_rsvDate, _o_this.state.sl_hdys) == true
        ) {
          if (pb_msg) alert(`指定した利用日が休館日であるため、指定された操作を行うことができません`); 
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        // 室の確認
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        let _rsvRoom = _d_i1zrs.d_flds.i1zrb41f;
        let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
        let _rsvMaxCnt = cf.myRN_getFldVal(_d_i1zrs, 'i1zrb41f', 'i10ri11i', 'i10ri11i');
        let _b_sgl = true;
        Promise.all(_d_i1zrs.dld_cldDatsss.i1z0
        .filter( _d_i1z0s => _d_i1z0s.b_dlt != true ? true : false)
        .map( async _d_i1z0s => {
          let _rsvTime = _d_i1z0s.d_flds.i1z0b51f;
          await i1zv1.op_loadSlcList({
            elm: 'i1z0',
            o_cnd: _dd_datss => {
              //let _cnd = `t_i1z0.i1z0b41f = ${_rsvRoom} AND t_i1z0.i1z0b51f = ${_rsvTime} AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
              let _cnd = `t_i1z0.i1z0b41f = ${_rsvRoom} AND t_i1z0.i1z0b51f = ${_rsvTime} AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90) AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = t_i1z0.i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt)`;
              if (_o_this.state.sgc_pageMode == 'edit') {
                _cnd += ` AND t_i1z0.i1z0b61k NOT IN (SELECT t_i1zr._key FROM t_i1zr WHERE {})`.f(cf.c('i1zr', `t_i1zr._fst = ${_o_this.state.sgc_pageFst}`)); // 自身以外の件数
              };
              _cnd = cf.c('i1z0', _cnd);
              return _cnd;
            },
          })
          .then(() => {
            let _n_cnt = ff.myCM_getLen(_o_this.state.sdld_i1z0SlcListsss.i1z0);
            if (
              (_o_this.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_rsvMaxCnt)) ||
              (_o_this.state.sgc_pageMode == 'edit' && _n_cnt+1 > ff.n(_rsvMaxCnt))
            ) {
              _b_sgl = false;
            }
          })
        }))
        .then(() => {
          if (
            _b_sgl == false
          ) {
            if (pb_msg) alert(`指定した室の時間帯に他の予約があるため、指定された操作を行うことができません`); 
            _o_end2(false);
          } else { _o_end2(true); };
        });
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
//      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) { // 新規登録時のみ
        // 設備の確認
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
        if (ff.myCM_getLen(_d_i1zrs.dld_cldDatsss?.i1z2) > 0 ) {
          let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
          let _b_sgl = true;
          Promise.all(
            _d_i1zrs.dld_cldDatsss?.i1z2
            .filter( _d_i1z2s => _d_i1z2s.b_dlt != true ? true : false)
            .map( _d_i1z2s => new Promise( _o_end3 => {
              let _rsvFly = _d_i1z2s.d_flds.i1z2b41f;
              let _rsvMaxCnt = _d_i1z2s.d_flds.i10ri11i;
              Promise.all(
                _d_i1zrs.dld_cldDatsss.i1z0
                .filter( _d_i1z0s => _d_i1z0s.b_dlt != true ? true : false)
                .map( _d_i1z0s => new Promise( _o_end4 => {
                  let _rsvSttTime = _d_i1z0s.d_flds.i110i11t;
                  let _rsvEndTime = _d_i1z0s.d_flds.i110i12t;
                  i1zv1.op_loadSlcList({
                    elm: 'i1z0',
                    o_cnd: _dd_datss => {
                      let _cnd1 = cf.c('i110', `i110i11t::NUMERIC::INTEGER < ${_rsvEndTime}  AND ${_rsvSttTime} < i110i12t::NUMERIC::INTEGER`);
                      let _cnd2 = cf.c('i1z2', `i1z2b41f = ${_rsvFly} AND i1z2b61k = i1z0b61k`);
                      //let _cnd = `(SELECT COUNT(*) FROM t_i1z2 WHERE ${_cnd2})>0 AND t_i1z0.i1z0b51f IN (SELECT _fst FROM t_i110 WHERE ${_cnd1}) AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
                      let _cnd = `EXISTS (SELECT * FROM t_i1z2 WHERE ${_cnd2}) AND t_i1z0.i1z0b51f IN (SELECT _fst FROM t_i110 WHERE ${_cnd1}) AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90) AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = t_i1z0.i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt)`;
                      if (_o_this.state.sgc_pageMode == 'edit') {
                        _cnd += ` AND t_i1z0.i1z0b61k NOT IN (SELECT t_i1zr._key FROM t_i1zr WHERE {})`.f(cf.c('i1zr', `t_i1zr._fst = ${_o_this.state.sgc_pageFst}`)); // 自身以外の件数
                      };
                      _cnd = cf.c('i1z0', _cnd);
                      return _cnd;
                    },
                  })
                  .then(() => {
                    let _n_cnt = ff.myCM_getLen(_o_this.state.sdld_i1z0SlcListsss.i1z0);
                    if (
                      (_o_this.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_rsvMaxCnt)) ||
                      (_o_this.state.sgc_pageMode == 'edit' && _n_cnt+1 > ff.n(_rsvMaxCnt))
                    ) {
                      _b_sgl = false;
                      _o_end4();
                    }
                    else {
                      _o_end4();
                    };
                  })
                }))
              )
              .then(() => {
                _o_end3();
              });
            }))
          )
          .then(() => {
            if (
              _b_sgl == false
            ) {
              if (pb_msg) alert(`指定した設備の時間帯に他の予約があるため、指定された操作を行うことができません`); 
              _o_end2(false);
            } else { _o_end2(true); };
          });
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),
    () => new Promise( _o_end2 => {
//ff.l('i1zv 601: {}'.f(_o_this.d_viewDefs.class, _o_this.state.sgc_pnlMode, _o_this.state.sgc_pageMode));
      if (bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && bf.i(_o_this.state.sgc_pageMode, ['new', 'edit'])) {
        let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
//ff.l('i1zv 603: {}'.f(_d_i1zrs))
        if (
          _d_i1zrs.d_flds.i1zrs11i > 0 || _d_i1zrs.d_flds.i1zrs21i > 0 ||  _d_i1zrs.d_flds.i1zrs22i > 0
        ) {
          _o_end2(true);
        } else { 
          if (pb_msg) alert(`処理の途中でエラーが発生したため、一度ログアウトした後、再度操作を行ってください`);
          _o_end2(false);
        };
      } else { _o_end2(true); };
    }),
  ])
  .then( _b_res => {
    cf.myRN_setStt({
      sgcb_chk: _b_res,
    })
    .then(() => {
      _o_end1(_b_res);
    });
  });
}) 

render() {

  const _o_this = this;

  let _n_lblW = ic.s(2 * 4);
  let _n_cnt = 14;
  let _n_w1 = (ic.gn_bdyW - _n_lblW) / _n_cnt;

  let _r = [];
  _r = _o_this._o_rdrTime();
/*
  _o_this.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の設定
    _r.push(
      ce.c(ce.Chk, {
        key: _i110Idx,
        frm: 'sqr',
        bsd: _d_i110s.d_flds.i110c31s,
        state: `s_time${_d_i110s.d_flds._fst}`,
        b_edit: bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']),
        b_row: true,
        n_col: 5,
        o_onChg: _n_chk => {          
          new Promise( _o_end1 => {
            let _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
            if ( _n_chk  == 1 ) { //　チェックされた場合
              let _b_est = false;
              let _b_dlt = false;
              _d_i1zrs.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                  _b_est = true;
                  if ( _d_i1z0s.b_dlt == true ) { // 削除済の場合
                    _b_dlt = true;
                  }; 
                };
              });
              if ( _b_est == false ) { // i1z0 が存在しない場合：　追加
                let _d_i1z0Dats = cf.myRN_crtDats({
                  elm: 'i1z0',
                  d_insFlds: {
                    i1z0b51f: _d_i110s.d_flds._fst ?? -1,
                    i110i11t: _d_i110s.d_flds.i110i11t ?? '',
                    i110i12t: _d_i110s.d_flds.i110i12t ?? '',
                  },
                });
                cf.myRN_addDats({
                  state: 'sdld_i1zrDtlsss',
                  als: 'i1z0',
                  d_dats: _d_i1z0Dats,
                  d_prtDats: _d_i1zrs,
                })
                .then(_o_end1);
              };
              if ( _b_est == true ) { // i1z0 が存在する場合：　更新
                if ( _b_dlt == true ) { // 削除済の i1z0 の場合
                  cf.myRN_setStt({
                    sdld_i1zrDtlsss: _next => {
                      let _d_crrDats = cf.myRN_getDat(_next, _d_i1zrs.ld_arsss);
                      _d_crrDats.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                        if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                          if ( _d_i1z0s.b_dlt == true ) { // 削除済の場合
                            _d_i1z0s.b_dlt = false;
                          }; 
                        };
                      });
                    }
                  })
                  .then(_o_end1);
                }
                else {
                  // 何もしない
                  _o_end1();
                };
              };
            };
            if ( _n_chk  == 0 ) { //　チェックが解除された場合
              cf.myRN_setStt({
                sdld_i1zrDtlsss: _next => {
                  let _d_crrDats = cf.myRN_getDat(_next, _d_i1zrs.ld_arsss);
                  _d_crrDats.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                    if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                      _d_i1z0s.b_dlt = true;
                    };
                  });
                }
              })
              .then(_o_end1)
            };
          })
          .then(() => {
            _o_this._op_updI1z1i31m() // 使用量の更新
            .then(() => {
              _o_this._op_updI1zrs11i(); // 予約状況の更新
            }); // 支払額の更新
          });
        }
      }),
    );
  });
*/

  let _r2 = [];
  if ( ff.n(_o_this.state.sgcd_stgs?._00070100) == 10 ) { // 設備を使用する場合
    _r2 = _o_this._o_rdrFly();
  };

  const _d_c30rs = _o_this.state.sdld_c30rDtlsss?.c30r[0];
  const _c30rc31s = (_d_c30rs) ? _d_c30rs.d_flds.c30rc31s : null; // 団体名
  const _i15rt11i = (_d_c30rs) ? _d_c30rs.d_flds.i15rt11i : null; // 利用料の有無 0:なし, 10:あり

  const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss?.i1zr[0];
  const _i1zrc11s = (_d_i1zrs) ? _d_i1zrs.d_flds.i1zrc11s : null; // ID
  const _i1zri11m = (_d_i1zrs) ? _d_i1zrs.d_flds.i1zri11m : null; // 利用料
  const _i1z1i31d = (_d_i1zrs) ? _d_i1zrs.d_flds.i1z1i31d : null; // 支払期日
  const _i1z1s11i = (_d_i1zrs) ? _d_i1zrs.d_flds.i1z1s11i : null; // 支払状況

//ff.l('I1zv1 693: {}'.f(_o_this.state.sgcd_stgs));

  return (
    ce.c(ce.RootDtl, 

      /* ----------------------------------------------------------------------------------------------------
      スタッフ用 直接予約・エントリー
      ---------------------------------------------------------------------------------------------------- */
      bf.i(_o_this.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) ?
        {
          key: -10,
          d_hdrs: {
            pfx:             
              (bf.i(_o_this.d_viewDefs.class, ['i1zv1a']) && _o_this.state.sgc_pnlMode == 'list') ?
                '直接予約一覧・登録'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1a']) && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode != 'new') ?
                '予約詳細・変更・キャンセル・削除'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1a']) && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規予約'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1b']) && _o_this.state.sgc_pnlMode == 'list') ?
                'エントリー一覧・登録'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1b']) && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規エントリー'
              : bf.i(_o_this.d_viewDefs.class, ['i1zv1b']) ?
                'エントリー'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1c']) && _o_this.state.sgc_pnlMode == 'list') ?
                '優先エントリー一覧・登録'
              : (bf.i(_o_this.d_viewDefs.class, ['i1zv1c']) && _o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pageMode == 'new') ?
                '新規優先エントリー'
              : bf.i(_o_this.d_viewDefs.class, ['i1zv1c']) ?
                '優先エントリー'
              : null,
            d_subs: 
              ff.i(_o_this.state.sgc_pageMode, ['new', 'edit']) == false ?
                {
                  iconName: 'users',
                  pfx: 'ユーザ切替',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: _o_this.state.sgc_pageRole,
                      sgc_pageName: 'c00v2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                }
              : null,
          },
          d_bdys: {
            l_clds: [

              /* ----------------------------------------------------------------------------------------------------
              スタッフ用 一覧
              ---------------------------------------------------------------------------------------------------- */
              ce.c(ce.Pnl, {
                key: -10,
                mode: 'list',
                b_vsb: _o_this.state.sgc_pnlMode == 'list' ? true : false,
                d_srls: {
                  state: 'sdld_i1zrSlcListsss',
                },
                d_hdrs: {
                  d_ctrs: {
                    l_clds: [
                      ce.c(ce.PckDate, cf.f('i1zri21d', { // 利用日
                        key: -1.1, 
                        b_vsb: true,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
//                        ini: _o_this.state.s_i1zri21dStt,
                        state: 's_i1zri21dStt',
                        n_col: 8,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      })),
                      ce.c(ce.PckDate, cf.f('i1zri21d', { // 利用日
                        pfx: '〜',
                        key: -1.2, 
                        b_vsb: true,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
//                        ini: _o_this.state.s_i1zri21dEnd,
                        state: 's_i1zri21dEnd',
                        n_col: 8,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      })),
                      ce.c(ce.PckSch, cf.f('i1zrb31f', { // 団体
                        key: -2, 
                        b_vsb: true,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
                        state: 's_i1zrb31f',
                        ld_iss: _o_this.state.sdld_c30rSlcListsss?.c30r,
                        n_col: 15,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      })),
                      ce.c(ce.Pck, cf.f('i1zrs11i', { // 予約状況
                        key: -3, 
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a') ? true : false,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
                        state: 's_i1zrs11i',
                        n_col: 9,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        },
                        ld_iss: [
                          { key:  -1, pfx: 'すべて' },
                          { key:  99, pfx: '仮予約＋本予約' },
                          { key:  80, pfx: '仮予約' },
                          { key:  90, pfx: '本予約' },
                          { key:  70, pfx: '仮押' },
                          { key:  60, pfx: '落選' },
                          { key:  20, pfx: 'キャンセル済' },
                        ],
                      })),
                      ce.c(ce.Pck, cf.f('i1zrs21i', { // エントリー状況
                        key: -4, 
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1b') ? true : false,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
                        state: 's_i1zrs21i',
                        n_col: 8,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        },
                        ld_iss: [
                          { key:  -1, pfx: 'すべて' },
                          { key:  40, pfx: 'エントリー中' },
                          { key:  80, pfx: '当選' },
                          { key:  60, pfx: '落選' },
                          { key:  20, pfx: 'キャンセル済' },
                        ],
                      })),
                      ce.c(ce.Pck, cf.f('i1zrs22i', { // 優先エントリー状況
                        key: -5, 
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1c') ? true : false,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
                        state: 's_i1zrs22i',
                        n_col: 8,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        },
                        ld_iss: [
                          { key:  -1, pfx: 'すべて' },
                          { key:  40, pfx: 'エントリー中' },
                          { key:  80, pfx: '当選' },
                          { key:  60, pfx: '落選' },
                          { key:  20, pfx: 'キャンセル済' },
                        ],
                      })),
                      ce.c(ce.BtnIconPfx, {
                        key: -6, 
                        b_vsb: true,
                        b_row: (ic.g_dvcMode == 's' ) ? false : true,
                        iconName: 'search',
                        pfx: '検索',
                        o_onPrs: () => _o_this.op_loadListAll(),
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      }),
                    ],
                  },
                  d_lefts: {
                    l_clds: [
                      ce.c(ce.BtnIconPfx, {
                        key: -2,
                        pfx: '予約一覧（EXCEL）',
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a') ? true : false,
                        b_row: true,
                        iconName: 'file-o',
                        o_onPrs: () => {
                          cf.myRN_showMdl({
                            mdl: 'cfm',
                            msg: 'ファイルのダウンロードは時間を要しますが、宜しいですか？',
                            ld_btnss: [
                              {
                                pfx: 'はい',
                                o_onPrs: _o_this._eptExl1a,
                              },
                              {
                                pfx: 'いいえ',
                                o_onPrs: () => {
                                },
                              }
                            ]
                          });
                        },
                        d_stlCtas: {
                          marginLeft: ic.s(1),
                        },
                      }),
/*
                      ce.c(ce.BtnIconPfx, {
                        key: -1,
                        pfx: '集計実績表（EXCEL）',
                        b_vsb: true,
                        b_row: true,
                        iconName: 'file-o',
                        o_onPrs: _o_this._eptExl1,
                        d_stlCtas: {
                          marginLeft: ic.s(2),
                        },
                      })
*/
                    ],
                  },
                  d_rhts: {
                    l_clds: [
                      ce.c(ce.BtnIconPfx, {
                        key: -10,
                        pfx: '予約状況カレンダー',
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a') ? true : false,
                        b_row: true,
                        iconName: 'square-o',
                        o_onPrs: () => {
                          let _url = String(ic.g_dmn).f(myWB.myWB_getDmn().subDmn) + '/i1zv4a';
                          myWB.myWB_open(_url);
                        },
                        d_stlCtas: {
                          marginRight: ic.s(1),
                        },
                      }),
                    ],
                  },
                },
                d_bdys: {
                  d_msgBfrs: {
                    pfx: 
                      ( _o_this.d_viewDefs.class == 'i1zv1a') ? // 直接予約
                        `【予約詳細の確認・変更・削除】・・・各予約のIDを押すと詳細画面に移動し、変更、削除もその画面で行えます。`
                      : ( _o_this.d_viewDefs.class == 'i1zv1b') ? // エントリー
                        `【エントリー詳細の確認・変更・削除】・・・各エントリーのIDを押すと詳細画面に移動し、変更、削除もその画面で行えます。`
                      : ( _o_this.d_viewDefs.class == 'i1zv1c') ? // 優先エントリー
                        `【優先エントリー詳細の確認・変更・削除】・・・各優先エントリーのIDを押すと詳細画面に移動し、変更、削除もその画面で行えます。`
                      : null,
                    n_mgnTop: ic.s(1),
                    d_stlCtas: {
                      minWidth: ic.gn_bdyW,
                    },
                  },
                  l_clds: [

                    ce.c(ce.Box, {
                      key: -10,
                      n_mgnTop: ic.s(1),
                    }, [
                      ce.c(cr.InpTree, {
                        key: -20,
                        state: 'sdld_i1zrSlcListsss',
                        dd_elmDefss: {
                          i1zr: {
                            elm: 'i1zr',
                            b_row: true,
                            b_ttl: false,
                            b_rootHdr: true,
                            d_stlHdrRows: {
                              height: ic.s(1.8),
                            },
                            d_stlBdyRows: {
                              height: ic.s(2.2),
                              marginTop: ic.s(0.2)
                            },
                            dd_fldDefss: 
                              ( _o_this.d_viewDefs.class == 'i1zv1a') ? // 直接予約
                                cf.myRN_getFldDefs([
                                  cf.f('i1zrc11s', {
                                    b_key: true,
                                    pfx: 'ID',
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                  }),
                                  cf.f('i1zri21d', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                  cf.f('i1zri62s', {
                                    b_tail:true,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10) },
                                  }),
                                  cf.f('i1zrb41f', {
                                    ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(10) },
                                  }),
                                  cf.f('c30rc31s', {
                                    b_tail: true,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15) },
                                  }),
                                  cf.f('i1zrs11i', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                ])
                              : ( _o_this.d_viewDefs.class == 'i1zv1b') ? // エントリー
                                cf.myRN_getFldDefs([
                                  cf.f('i1zrc11s', {
                                    b_key: true,
                                    pfx: 'ID',
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                  }),
                                  cf.f('i1zri21d', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                  cf.f('i1zri62s', {
                                    b_tail:true,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10) },
                                  }),
                                  cf.f('i1zrb41f', {
                                    ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(10) },
                                  }),
                                  cf.f('c30rc31s', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15) },
                                  }),
                                  cf.f('i1zrs21i', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                ])
                              : ( _o_this.d_viewDefs.class == 'i1zv1c') ? // 優先エントリー
                                cf.myRN_getFldDefs([
                                  cf.f('i1zrc11s', {
                                    b_key: true,
                                    pfx: 'ID',
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(6) : ic.s(6) },
                                  }),
                                  cf.f('i1zri21d', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                  cf.f('i1zri62s', {
                                    b_tail:true,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10) },
                                  }),
                                  cf.f('i1zrb41f', {
                                    ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r,
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(10)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(10) },
                                  }),
                                  cf.f('c30rc31s', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(15) : ic.s(15) },
                                  }),
                                  cf.f('i1zrs22i', {
                                    d_hdrs: { n_w: (ic.g_dvcMode == 's') ? ic.s(8) : ic.s(8)  },
                                    d_bdys: { n_w: (ic.g_dvcMode == 's') ? ic.s(7+1) : ic.s(8) },
                                  }),
                                ])
                              : null
                            ,
                          },
                        },
                      }),
                    ]),
                  ],
                },
                d_btms: {
                  d_news: {
                  },
                  l_clds: [
                    ce.c(ce.Box, {
                      key: -2,
                      stlCta: {
                        minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
//                        width: ic.gn_minBdyW,
                        width: ic.gn_minBdyW * 1.5,
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        marginTop: ic.s(0.5), // 20211202
                        marginBottom: ic.s(0.5), // 20211202
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }
                    }, [
//                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                        ce.c(ce.Btn, {
                          key: -10,
//                          pfx: '新規予約の登録',
                          pfx: '新規予約の個別登録',
                          stlBtn: {
                            width: ic.s(10),
                          },
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              elm: 'i1zr',
                              state: 'sdld_i1zrDtlsss',
                              opb_chkIns: _o_this.$opb_chk,
                              d_insFlds: {
                                ...cf.e('i1zr').d_insFlds, 
                                i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f, // 団体用
                                i1zrs11i: 80, // 直接予約
                                i1zrs21i: 0, // エントリー
                                i1zrs22i: 0, // 優先エントリー
                              },
                              op_atrAll: () => new Promise( _o_end1 => {
                                _o_this._op_onChgI1zrb31f({
                                  i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f,
                                })
                                .then( () => {
                                  _o_end1();
                                });
                              }),
                              mode: 'sttNew',
                              b_clr: true, // 現行要素の初期化に必要
                            })
                          },
                        })
                      : null,
//                      (_o_this.d_viewDefs.class == 'i1zv1b') ?
                      (_o_this.d_viewDefs.class == 'i1zv1b') ?
                        ce.c(ce.Btn, {
                          key: -10,
                          pfx: '新規エントリーの登録',
                          stlBtn: {
                            width: ic.s(12),
                          },
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              elm: 'i1zr',
                              state: 'sdld_i1zrDtlsss',
                              opb_chkIns: _o_this.$opb_chk,
                              d_insFlds: {
                                ...cf.e('i1zr').d_insFlds, 
                                i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f, // 団体用
                                i1zrs11i: 0, // 直接予約
                                i1zrs21i: 40, // エントリー
                                i1zrs22i: 0, // 優先エントリー
                              },
                              op_atrAll: () => new Promise( _o_end1 => {
                                _o_this._op_onChgI1zrb31f({
                                  i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f,
                                })
                                .then( () => {
                                  _o_end1();
                                });
                              }),
                              mode: 'sttNew',
                              b_clr: true, // 現行要素の初期化に必要
                            })
                          },
                        })
                      : null,
//                      (_o_this.d_viewDefs.class == 'i1zv1c') ?
                      (_o_this.d_viewDefs.class == 'i1zv1c') ?
                        ce.c(ce.Btn, {
                          key: -10,
                          pfx: '新規優先エントリーの登録',
                          stlBtn: {
                            width: ic.s(14),
                          },
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              elm: 'i1zr',
                              state: 'sdld_i1zrDtlsss',
                              opb_chkIns: _o_this.$opb_chk,
                              d_insFlds: {
                                ...cf.e('i1zr').d_insFlds, 
                                i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f, // 団体用
                                i1zrs11i: 0, // 直接予約
                                i1zrs21i: 0, // エントリー
                                i1zrs22i: 40, // 優先エントリー
                              },
                              op_atrAll: () => new Promise( _o_end1 => {
                                _o_this._op_onChgI1zrb31f({
                                  i1zrb31f: _o_this.state.sgcd_cmnStgs?.c10rb31f,
                                })
                                .then( () => {
                                  _o_end1();
                                });
                              }),
                              mode: 'sttNew',
                              b_clr: true, // 現行要素の初期化に必要
                            })
                          },
                        })
                      : null,
//                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                        ce.c(ce.Btn, {
                          key: -20,
//                          pfx: '予約の一括登録',
                          pfx: '定期予約の一括登録',
                          stlBtn: {
                            width: ic.s(10),
                          },
                          o_onPrs: () => {
                            let _d_pageInfs = {
                              sgc_pageRole: _o_this.state.sgc_pageRole,
                              sgc_pageName: 'i1zv5a',
                              sgc_pageMode: 'show',
                            }; 
                            cf.myRN_move_fwd(_d_pageInfs);
                          },
                        })
                      : null,
                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                        ce.c(ce.Btn, {
                          key: -30,
                          pfx: '月間予約の一括登録',
                          stlBtn: {
                            width: ic.s(10),
                          },
                          o_onPrs: () => {
                            let _d_pageInfs = {
                              sgc_pageRole: _o_this.state.sgc_pageRole,
                              sgc_pageName: 'i1zv7a',
                              sgc_pageMode: 'show',
                            }; 
                            cf.myRN_move_fwd(_d_pageInfs);
                          },
                        })
                      : null,
                    ])
                  ],
                },
              }),

              /* ----------------------------------------------------------------------------------------------------
              スタッフ用 新規・変更
              ---------------------------------------------------------------------------------------------------- */
              ce.c(ce.Pnl, {
                key: -2,
                mode: 'dtl',
                b_vsb: (_o_this.state.sgc_pnlMode == 'dtl' && _o_this.state.sgc_pnlPhs == 'ini') ? true : false,
                d_hdrs: {
                  d_lefts: {
                    l_clds: [
                      ce.c(ce.BtnIconPfx, {
                        key: -1,
                        pfx: '利用申請書発行（PDF）',
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a' && bf.i(_o_this.state.sgc_pageMode, ['show'])) ? true : false,
                        b_row: true,
                        iconName: 'file-o',
                        o_onPrs: () => {
                          i1zv._eptPdf1();
                        },
                        d_stlCtas: {
                          marginLeft: ic.s(2),
                        },
                      })
                    ],
                  },
                  d_htys: {
                    elm: 'i1zr',
                    ld_iss: _o_this.state.sdld_i1zrVsnListsss?.i1zr,
                    op_loadDtl: i1zv.op_loadDtl,
                  },
                },
                d_bdys:{
                  d_msgBfrs: {
//                    pfx: `・枠中のテキストは変更できます。・右肩に×のある欄・・・×で取り消し、それ以外を押すと入力を選択できます。\n【各室の予約状況】・・・希望する「室」と「利用日時」を選択すると表示されます。 ×は予約できません。`,
                    pfx:
                      ( _o_this.d_viewDefs.class == 'i1zv1a' && bf.i(_o_this.state.sgc_pageMode, ['new']) ) ? 
                        `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時は予約できません。`
                      : ( _o_this.d_viewDefs.class == 'i1zv1a' ) ? 
                        `■枠中のテキストは変更できます。■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時は予約できません。`
                      : ( _o_this.d_viewDefs.class == 'i1zv1b' && bf.i(_o_this.state.sgc_pageMode, ['new']) ) ? 
//                        `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時はエントリーできません。`
                        `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。\n★予約状況の見方　△：他団体のエントリー有　×：予約不可`
                      : ( _o_this.d_viewDefs.class == 'i1zv1b' ) ? 
//                        `■枠中のテキストは変更できます。■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時はエントリーできません。`
                        `■抽選前のエントリーのみ以下の操作で変更できます。\n■枠中のテキストは変更できます。■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。\n★予約状況の見方　△：他団体のエントリー有　×：予約不可`
                      : ( _o_this.d_viewDefs.class == 'i1zv1c' && bf.i(_o_this.state.sgc_pageMode, ['new']) ) ? 
//                        `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時は優先エントリーできません。`
                        `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。\n★予約状況の見方　△：他団体のエントリー有　×：予約不可`
                      : ( _o_this.d_viewDefs.class == 'i1zv1c' ) ? 
//                        `■枠中のテキストは変更できます。■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時は優先エントリーできません。`
                        `■抽選前のエントリーのみ以下の操作で変更できます。\n■枠中のテキストは変更できます。■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。\n★予約状況の見方　△：他団体のエントリー有　×：予約不可`
                      : null,
                    n_mgnTop: ic.s(1),
                    d_stlCtas: {
                      minWidth: ic.gn_bdyW,
                    },
                  },
                  l_clds: [                    

                    ce.c(ce.Box, {
                      key: -1,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(1),
                      d_stlCtas: {
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      },
                    }, [

                      ce.c(ce.Row, {
                        key: -10,
                        b_vsb: 
                          bf.i(_o_this.state.sgc_pageMode, ['show', 'edit', 'hsy']), // new は非表示
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -1,
                          b_vsb: 
                            bf.i(_o_this.state.sgc_pageMode, ['show', 'edit', 'hsy']), // new は非表示
                          state: 'sdld_i1zrDtlsss',                  
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: false,
                              d_cmns: { n_cnt: 3 },
                              dd_fldDefss: 
                                (_o_this.d_viewDefs.class == 'i1zv1a') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zrc11s', { // ID
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5)  },
                                      d_bdys: { n_w: ic.s(5+11) },
                                    }),
                                    cf.f('i1zrs11i', { // 予約状況
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(6)  },
                                      d_bdys: { n_w: ic.s(10+6) },
                                    }),
                                    cf.f('i1zri11d', { // 申込日
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(10+6+1) },
                                    }),
                                  ])
                                : (_o_this.d_viewDefs.class == 'i1zv1b') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zrc11s', { // ID
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5)  },
                                      d_bdys: { n_w: ic.s(5+11) },
                                    }),
                                    cf.f('i1zrs21i', { // エントリー状況
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(6)  },
                                      d_bdys: { n_w: ic.s(10+6) },
                                    }),
                                    cf.f('i1zri11d', { // 申込日
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(10+6+1) },
                                    }),
                                  ])
                                : (_o_this.d_viewDefs.class == 'i1zv1c') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zrc11s', { // ID
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5)  },
                                      d_bdys: { n_w: ic.s(5+11) },
                                    }),
                                    cf.f('i1zrs22i', { // 優先エントリー状況
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(6)  },
                                      d_bdys: { n_w: ic.s(10+6) },
                                    }),
                                    cf.f('i1zri11d', { // 申込日
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(10+6+1) },
                                    }),
                                  ])
                                : null,
                            },
                          },
                        }),
                      ]),

                      ce.c(ce.Row, {
                        key: -20,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -2,
                          state: 'sdld_i1zrDtlsss',
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: false,
                              d_cmns: { n_cnt: 3 },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i1zrb31f', { // 団体
                                  b_tail: true,
                                  ob_edit: _d_dats => 
                                    (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
                                  ld_iss: _o_this.state.sdld_c30rSlcListsss?.c30r,
                                  o_onChg: _d_dats => {
                                    _o_this._op_onChgI1zrb31f({
                                      i1zrb31f: _d_dats.d_flds.i1zrb31f,
                                    })
                                    .then(() => {
                                      _o_this._op_updI1z1i31m() // 支払額の計算
                                      _o_this._op_updI1zrs11i(); // 進捗の更新
                                    });
                                  },
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(16) },
                                }),
                                cf.f('i1zri31s', { // 代表者
                                  b_edit: false,
//                                  d_hdrs: { n_w: ic.s(5) },
                                  d_hdrs: { n_w: ic.s(6) },
                                  d_bdys: { n_w: ic.s(10+6) },
                                }),
                                cf.f('i1zri32s', { //　利用制限
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(10+6+1) },
                                }),
                              ]),
                            },
                          },
                        }),
                      ]),

                      ce.c(ce.Row, {
                        key: -30,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -2,
                          state: 'sdld_i1zrDtlsss',
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: false,
                              d_cmns: { n_cnt: 3 },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i1zri11s', { // 申込者
                                  ob_edit: _d_dats => 
                                    (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(11+5) },
                                }),
                                cf.f('i1zri12s', { // 連絡先
                                  ob_edit: _d_dats => 
                                    (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
//                                  d_hdrs: { n_w: ic.s(5) },
                                  d_hdrs: { n_w: ic.s(6) },
                                  d_bdys: { n_w: ic.s(11+5) },
                                }),
                              ]),
                            },
                          },
                        }),
                      ]),

                      ce.c(ce.Row, {
                        key: -40,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -3,
                          state: 'sdld_i1zrDtlsss',
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: false,
                              d_cmns: { n_cnt: 3 },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i1zri41s', { // 内容
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(11+5) },
                                }),
                                cf.f('i1zri41i', { // 人数
                                  bsd: '人',
//                                  d_hdrs: { n_w: ic.s(5) },
                                  d_hdrs: { n_w: ic.s(6) },
                                  d_bdys: { n_w: ic.s(7+9) },
                                }),
/*
                                cf.f('i1zrt41i', { // 貸出備品
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(6+10+1) },
                                }),
*/
                              ]),
                            },
                          },
                        }),
                      ]),

                      ce.c(ce.Row, {
                        key: -50,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -4,
                          state: 'sdld_i1zrDtlsss',
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: false,
                              d_cmns: { n_cnt: 1 },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i1zrb41f', { // 室
                                  pfx: '室',
                                  b_dmy: true,
                                  ld_iss: _o_this.state.sdld_i10rSlcListsss?.i10r.filter( _d_i10rs => (_d_i10rs.d_flds.i10rt11i == 200) ? true : false),
                                  d_hdrs: { n_w: ic.s(5) },
                                  d_bdys: { n_w: ic.s(11+5) },
                                  o_onChg: _d_dats => {
                                    i11v1a.op_loadSlcList({ // 時間帯
                                      elm: 'i110',
                                      i11r_fst: cf.myRN_getFldVal(_d_dats, 'i1zrb41f', 'i10rb51f', 'i10rb51f'),
                                    })
                                    .then(() => { // カレンダー

                                      _o_this.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の初期化
                                        cf.myRN_setStt({
                                          [`s_time${_d_i110s.d_flds._fst}`]: 0,
                                        });
                                      });

                                      _o_this._op_loadCdrList2({
                                        state1: `sdld_cdrListsss2`,
                                        state2: `sl_dates2`,
                                        date: _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                                      })
                                      .then(()=>{
                                        _o_this._op_updI1z1i31m() // 利用料・支払額の更新
                                        .then(() => {
                                          _o_this._op_updI1zrs11i(); // 進捗の更新
                                        });
                                      })
                                    })                                  
                                  }
                                }),
                              ]),
                            },
                          },
                        }),
                        _r2,
                      ]),

                      ce.c(ce.Row, {
                        key: -60,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(ce.Row, {
                          key: -60,
                          n_w: ic.s(64),
                          n_mgnTop: ic.s(0.2)
                        }, [
                          ce.c(cr.InpTree, {
                            key: -6,
                            state: 'sdld_i1zrDtlsss',
                            dd_elmDefss: {
                              i1zr: {
                                elm: 'i1zr',
                                b_row: false,
                                d_cmns: { n_cnt: 1 },
                                dd_fldDefss: cf.myRN_getFldDefs([
                                  cf.f('i1zri21d', { // 利用日
                                    pfx: '利用日時',
                                    o_onChg: _d_dats => {
                                      _o_this._op_loadCdrList2({
                                        state1: `sdld_cdrListsss2`,
                                        state2: `sl_dates2`,
                                        date: _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                                      })
                                      .then(() => {
                                        _o_this._op_updI1zrs11i(); // 進捗の更新
                                      });
                                    },
                                    d_hdrs: { n_w: ic.s(5) },
                                    d_bdys: { n_w: ic.s(9) },
                                  }),
                                ]),
                              },
                            },                          
                          }),
                          _r,
                        ]),
                      ]),

//                      (ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ?
                      (_o_this.d_viewDefs.class == 'i1zv1a') ?
                      ce.c(ce.Lbl, {
                        key: -65,
                        pfx: '支払い',
                        b_rvs: true,
                        d_stlCtas: {
                          width: _o_this.state.sgcd_dmns.n_bdyW,
                          height: ic.s(2),
                          borderWidth: 0,
                          borderTopWidth: ic.b(1.6),
                          borderColor: ic.o_getCcd('d'),
                          marginTop: ic.s(0.5),
                          marginBottom: ic.s(0.25),
                        },
                        d_stlLbls: {
                          backgroundColor: ic.o_getCcd('d'),
                          width: ic.s(8),
                          height: ic.s(2),
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                      })
                      : null,

                      //(ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ?
                      (_i15rt11i == 10) ? // 20220519
                      ce.c(ce.Row, {
                        key: -70,
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a') ? true : false,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -10,
                          state: 'sdld_i1zrDtlsss',
//                          b_vsb: (ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ? true : false,
                          b_vsb: true,
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              d_cmns: { n_cnt: 4 },
                              dd_fldDefss:
                                (_o_this.d_viewDefs.class == 'i1zv1a') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zri11m', {
                                      b_edit: false,
                                      o_onChg: _o_this._op_updI1z1i31m,
                                      bsd: '円',
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1t21i', {
                                      ob_edit: _d_dats => 
                                        (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90) ? true : false,
                                      o_onChg: _d_dats => {
                                        if (_d_dats.d_flds.i1z1t21i != 999){
                                          cf.myRN_setDat('sdld_i1zrDtlsss', _d_dats, _d_dats => {
                                            let _i1z1i21i = _d_dats.d_flds.i1z1t21i;
                                            return {
                                              i1z1i21i: _i1z1i21i,
                                            };
                                          })
                                          .then(_o_this._op_updI1z1i31m); // 999 は i1z1i21i 設定後
                                        }
                                      },
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1i21i', {
                                      ob_edit: _d_dats => 
                                        (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && _d_dats.d_flds.i1zrs11i < 90 && _d_dats.d_flds.i1z1t21i == 999) ? true : false,
                                      o_onChg: _o_this._op_updI1z1i31m,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1i21m', {
                                      b_edit: false,
                                      bsd: '円',
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                  ])
                                : (_o_this.d_viewDefs.class == 'i1zv1b') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zri11m', {
                                      b_edit: false,
                                      bsd: '円',
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+9) },
                                    }),
                                  ])
                                : (_o_this.d_viewDefs.class == 'i1zv1c') ?
                                  cf.myRN_getFldDefs([
                                    cf.f('i1zri11m', {
                                      b_edit: false,
                                      bsd: '円',
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+9) },
                                    }),
                                  ])
                                : null,
                            },
                          },
                        }),
                      ])
                      : null,

//                      (ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ?
                      ce.c(ce.Row, {
                        key: -80,
                        b_vsb: (_o_this.d_viewDefs.class == 'i1zv1a') ? true : false,
                        n_w: ic.s(64),
                        n_mgnTop: ic.s(0.2)
                      }, [
                        ce.c(cr.InpTree, {
                          key: -10,
                          state: 'sdld_i1zrDtlsss',
//                          b_vsb: (ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ? true : false,
                          b_vsb: true,
                          dd_elmDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              d_cmns: { n_cnt: 4 },
                              dd_fldDefss:
                                //(_o_this.d_viewDefs.class == 'i1zv1a' && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i == 10) ?
                                (_o_this.d_viewDefs.class == 'i1zv1a' && _i15rt11i == 10) ? // 20220519
                                  cf.myRN_getFldDefs([
                                    cf.f('i1z1i31m', {
                                      b_edit: false,
                                      bsd: '円',
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1i31d', {
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1i41d', {
                                      o_onChg: _d_dats => {
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _d_dats, _d_dats => {
                                          let _d = {
                                            i1z1s11i: ff.f(_d_dats.d_flds.i1z1i41d) ? 10 : 0,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
                                          _o_this._op_updI1zrs11i();
                                        })
                                      },
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1s11i', {
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                  ])
                                //: (_o_this.d_viewDefs.class == 'i1zv1a' && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zrt21i != 10) ?
                                : (_o_this.d_viewDefs.class == 'i1zv1a' && _i15rt11i != 10) ? // 20220519
                                  cf.myRN_getFldDefs([
                                    cf.f('i1z1i31m', {
                                      b_edit: false,
                                      bsd: '円',
                                      o_stlVal: () => 0, // add
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1i41d', {
                                      pfx: '支払確認日',
                                      o_onChg: _d_dats => {
                                        cf.myRN_setDat('sdld_i1zrDtlsss', _d_dats, _d_dats => {
                                          let _d = {
                                            i1z1s11i: ff.f(_d_dats.d_flds.i1z1i41d) ? 10 : 0,
                                          };
                                          return _d;
                                        })
                                        .then(() => {
                                          _o_this._op_updI1zrs11i();
                                        })
                                      },
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                    cf.f('i1z1s11i', {
                                      pfx: '確認状況',
                                      ld_iss: [
                                        { key:  -1, pfx: ' ' },
                                        { key:   0, pfx: '未確認' },
                                        { key:  10, pfx: '確認済' },
                                      ],
                                      b_edit: false,
                                      d_hdrs: { n_w: ic.s(5) },
                                      d_bdys: { n_w: ic.s(7+4) },
                                    }),
                                  ])
                                : null,
                            },
                          },
                        }),
                      ]),
//                      : null,

                    ]),

                    ce.c(ce.Row, {
                      key: -90,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.3)
                    }, [
                      ce.c(cr.InpTree, {
                        key: -6,
                        state: 'sdld_i1zrDtlsss',
                        dd_elmDefss: {
                          i1zr: {
                            elm: 'i1zr',
                            b_row: false,
                            d_cmns: { n_cnt: 1 },
                            dd_fldDefss: cf.myRN_getFldDefs([
                              cf.f('i1zri51s', { // メモ
                                d_hdrs: { n_w: ic.s(5) },
                                d_bdys: { n_w: ic.s(62) },
                              }),
                            ]),
                          },
                        },                          
                      }),
                    ]),

                    (
                      bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && 
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                      _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0 &&
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d)
                    ) ?
                    ce.c(ce.Lbl, {
                      key: -8,
                      pfx: '予約状況',
                      b_vsb: (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0) ? true : false,
                      d_stlCtas: {
                        marginTop: ic.s(1), // 20211202                        
                      },
                      stlLbl: {
                      },
                    })
                    :null ,

                    (
                      bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && 
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                      _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0 &&
                      ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d)
                    ) ?
                      ce.c(ce.Tbl2, {
                        key: -9,
                        pfx: `${(ff.f(_o_this.state[`sl_dates2`])) ? _o_this.state[`sl_dates2`][0] : ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), 2)} 〜`,
                        b_vsb: (bf.i(_o_this.state.sgc_pageMode, ['new', 'edit']) && ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrb41f > 0) ? true : false,
                        b_ctg: true,
                        b_tgt: true,
                        state: `sdld_cdrListsss2`,
                        l_cmns: _o_this.state[`sl_dates2`] ?? [],
//                        o_hat: (_cmn, _cmnIdx) => (_cmnIdx == 0 || ff.myDT_cnv('day', _cmn) == 1) ? `${ff.myDT_cnv('mth', _cmn)}月` : '',
//                        o_pfx: _cmn => `${ff.myDT_cnv('day', _cmn)}日`,
                        o_hat: (_cmn, _cmnIdx) => (_cmnIdx == 0 || ff.myDT_cnv('day', _cmn) == 1) ? `${ff.myDT_cnv('mth', _cmn)}` : '',
                        o_pfx: _cmn => `${ff.myDT_cnv('day', _cmn)}`,
                        o_sfx: _cmn => {
                          let _s = 
                            ff.i( _cmn, _o_this.state.sl_hdys ) ?
//                              '休館'
                              '休'
//                            : `(${ff.myDT_cnv('dow', _cmn)})`;
                            : `${ff.myDT_cnv('dow', _cmn)}`;
                          return _s;
                        }, 
                        od_stlLbls: () => {
                          let _d = 
                            {
//                              flex: _n_lblW,
                              width: _n_lblW,
                              backgroundColor: ic.o_getCcd('h'),
                              paddingLeft: ic.m(1),
                              paddingRight: ic.m(1),
                            };
                          return _d;
                          
                        },
                        od_stlCells: (_cmn, _cmnIdx) => {          
                          let _d = {
                            flex: _n_w1,
                            backgroundColor:
                              ff.i( _cmn, _o_this.state.sl_hdys ) ?
                                ic.g_ccdHN 
                              : ((_cmnIdx + 1) % 2 == 0) ? 
                                ic.o_getCcd('h') 
                              : ic.g_ccdWN,
                          };
                          return _d;
                        },
                        od_stlCtgRows: () => {          
                          let _d = {
                            minHeight: ic.s(2),
                          };
                          return _d;
                        },
                        od_stlDtlRows: () => {          
                          let _d = {
                              minHeight: ic.s(2),
                          };
                          return _d;
                        },
                      })
                    : null,

                    ff.f(_o_this.state.sdld_c30rDtlsss?.c30r) ?
                      ce.c(ce.Lbl, {
                        key: -65,
                        pfx: 'この団体の現在のエントリー・予約状況（直近30件）',
                        b_rvs: true,
                        d_stlCtas: {
                          width: _o_this.state.sgcd_dmns.n_bdyW,
                          height: ic.s(2),
                          borderWidth: 0,
                          borderTopWidth: ic.b(1.6),
                          borderColor: ic.o_getCcd('d'),
                          marginTop: ic.s(0.5),
                          marginBottom: ic.s(0.25),
                        },
                        d_stlLbls: {
                          backgroundColor: ic.o_getCcd('d'),
                          width: ic.s(23),
                          height: ic.s(2),
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                      })
                    : null,

                    ce.c(cr.InpTree, {
                      key: -100,
                      state: 'sdld_c30rDtlsss',
                      b_vsb: ff.f(_o_this.state.sdld_c30rDtlsss?.c30r) ? true : false,
                      d_stlCtas: {
                        marginTop: ic.s(1), // 20211202                        
                      },
                      dd_elmDefss: {
                        c30r: {
                          elm: 'c30r',
                          dd_cldDefss: {
                            i1zr: {
                              elm: 'i1zr',
                              b_row: true,
                              b_subHdr: true,
                              b_ttl: false,
                              b_lyr: false,
                              d_stlHdrRows: {
                                borderWidth: 0,
                                borderBottomWidth: ic.b(1),
                                borderColor: ic.g_ccdHP,
                              },
                              d_stlBdyRows: {
                                borderWidth: 0,
                                borderBottomWidth: ic.b(0.5),
                                borderColor: ic.g_ccdHP,
                              },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i1zrc11s', {
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(12) },
                                  d_bdys: { n_w: ic.s(12) },
                                }),
                                cf.f('i1zri21d', {
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(13) },
                                  d_bdys: { n_w: ic.s(13) },
                                }),
                                cf.f('i1zrs22i', {
                                  pfx: '優先エントリー状況',
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(13) },
                                  d_bdys: { n_w: ic.s(13) },
                                }),
                                cf.f('i1zrs21i', {
                                  pfx: 'エントリー状況',
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(13) },
                                  d_bdys: { n_w: ic.s(13) },
                                }),
                                cf.f('i1zrs11i', {
                                  pfx: '予約状況',
                                  b_edit: false,
                                  d_hdrs: { n_w: ic.s(13) },
                                  d_bdys: { n_w: ic.s(13) },
                                }),
                              ]),
                            },
                          },
                        },
                      },
                      d_stlCtas: {
                        marginTop: ic.s(1),
                      },
                    })

                  ],
                },

                d_btms:{
                  l_clds: [

                    ce.c(ce.Box, {
                      key: -2,
                      d_stlCtas: {
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        width: ic.gn_minBdyW,
                        marginTop: ic.s(0.5), // 20211202
                        marginBottom: ic.s(0.5), // 20211202
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }
                    }, [
                      bf.i(_o_this.state.sgc_pageMode, ['show']) ?
                        ce.c(ce.Box, {
                          key: -155,
                          stlCta: {
                            minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: ic.gn_bdyW - ic.m(2, true),
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                          }
                        }, [

                          (_o_this.d_viewDefs.class == 'i1zv1a') ?
                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '予約一覧に戻る',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPnlMode({
                                mode: 'list',
                              });
                            },
                          })
                          : null,

                          (_o_this.d_viewDefs.class == 'i1zv1b') ?
                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '前の画面に戻る',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPnlMode({
                                mode: 'list',
                              });
                            },
                          })
                          : null,

                          (_o_this.d_viewDefs.class == 'i1zv1c') ?
                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '前の画面に戻る',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPnlMode({
                                mode: 'list',
                              });
                            },
                          })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1a' && 
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs11i > 70
                          ) ?
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この予約の変更画面へ',
                            stlBtn: {
                              width: ic.s(12),
                            },
                            o_onPrs: () => {
                              _o_this.$opb_chk()
                              .then( _b_res => {
                                if (_b_res) {
                                  cf.myRN_chgPageMode({
                                    mode: 'sttEdit',
                                  })
                                  .then(() => {
                                    _o_this._op_loadCdrList2({
                                      state1: `sdld_cdrListsss2`,
                                      state2: `sl_dates2`,
                                      date: _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                                    });
                                  });
                                };
                              });
                            },
                          })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1b' &&
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs21i == 40
                          ) ?
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この情報を変更',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: 'black',
                            },
                            o_onPrs: () => {
                              _o_this.$opb_chk()
                              .then( _b_res => {
                                if (_b_res) {
                                  cf.myRN_chgPageMode({
                                    mode: 'sttEdit',
                                  })
                                  .then(() => {
                                    _o_this._op_loadCdrList2({
                                      state1: `sdld_cdrListsss2`,
                                      state2: `sl_dates2`,
                                      date: _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                                    });
                                  });
                                };
                              });
                            },
                          })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1c' &&
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs22i == 40
                          ) ?
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この情報を変更',
                            stlBtn: {
                              width: ic.s(8),
                            },
                            o_onPrs: () => {
                              _o_this.$opb_chk()
                              .then( _b_res => {
                                if (_b_res) {
                                  cf.myRN_chgPageMode({
                                    mode: 'sttEdit',
                                  })
                                  .then(() => {
                                    _o_this._op_loadCdrList2({
                                      state1: `sdld_cdrListsss2`,
                                      state2: `sl_dates2`,
                                      date: _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                                    });
                                  });
                                };
                              });
                            },
                          })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1a' && 
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs11i > 70
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'この予約をキャンセル',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(12),
//                                backgroundColor: ic.g_ccdHN,
//                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                  () => {
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'この予約をキャンセルして宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.s();
                                            cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                              let _d = {
                                                i1zrs11i: 20,
                                              };
                                              return _d;
                                            })
                                            .then(() => {
                                              _o_this.op_upd()
                                              .then(() => {
                                                if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                                  const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                                  let _ttl = 
                                                    `ご予約のキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                                  let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記ご予約のキャンセルを受け付けましたので、ご連絡致します。

<<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                                  const _l_tos = [];
                                                  if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                                  if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                                  if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                                  const _l_bccs = [ic.g_mail];
                                                  if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                                  cf.myCB_call_eml(
                                                    _l_tos,
                                                    _ttl,
                                                    _msg,
                                                    _l_bccs
                                                  )
                                                  .then(() => {
                                                    _o_this.op_loadDtlAll({b_clr: false})
                                                    .then(() => {
                                                      cf.myRN_savePageStgs({
                                                        sgc_pageMode: 'show',
                                                      })
                                                      .then(() => {
                                                        cf.h();
                                                      });
                                                    });
                                                  });
                                                }
                                                else {
                                                  _o_this.op_loadDtlAll({b_clr: false})
                                                  .then(() => {
                                                    cf.myRN_savePageStgs({
                                                      sgc_pageMode: 'show',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                };
                                              });
                                            })
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
                                  },
                            })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1b' &&
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs21i == 40
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'このエントリーをキャンセル',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(14),
                                backgroundColor: ic.g_ccdHN,
                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                () => {
                                  cf.myRN_showMdl({
                                    mdl: 'cfm',
                                    msg: 'キャンセルして宜しいですか？',
                                    ld_btnss: [
                                      {
                                        pfx: 'はい',
                                        o_onPrs: () => {
                                          cf.s();
                                          cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                            let _d = {
                                              i1zrs21i: 20,
                                            };
                                            return _d;
                                          })
                                          .then(() => {
                                            _o_this.op_upd()
                                            .then(() => {
/*
                                              _o_this.op_loadDtlAll({b_clr: false})
                                              .then(() => {
                                                cf.myRN_savePageStgs({
                                                  sgc_pageMode: 'show',
                                                })
                                                .then(() => {
                                                  cf.h();
                                                });
                                              });
*/
                                              if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                                const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                                let _ttl = 
                                                  `エントリーのキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                                let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記エントリーのキャンセルを受け付けましたので、ご連絡致します。

<<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                                const _l_tos = [];
                                                if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                                if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                                if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                                const _l_bccs = [ic.g_mail];
                                                if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                                cf.myCB_call_eml(
                                                  _l_tos,
                                                  _ttl,
                                                  _msg,
                                                  _l_bccs
                                                )
                                                .then(() => {
                                                  _o_this.op_loadDtlAll({b_clr: false})
                                                  .then(() => {
                                                    cf.myRN_savePageStgs({
                                                      sgc_pageMode: 'show',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                });
                                              }
                                              else {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              };
                                            });
                                          })
                                        },
                                      },
                                      {
                                        pfx: 'いいえ',
                                        o_onPrs: () => {
                                        },
                                      }
                                    ]
                                  });
                                }
                            })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1c' &&
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs22i == 40
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'この優先エントリーをキャンセル',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(16),
                                backgroundColor: ic.g_ccdHN,
                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                () => {
                                  cf.myRN_showMdl({
                                    mdl: 'cfm',
                                    msg: 'キャンセルして宜しいですか？',
                                    ld_btnss: [
                                      {
                                        pfx: 'はい',
                                        o_onPrs: () => {
                                          cf.s();
                                          cf.myRN_setDat('sdld_i1zrDtlsss', _o_this.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
                                            let _d = {
                                              i1zrs22i: 20,
                                            };
                                            return _d;
                                          })
                                          .then(() => {
                                            _o_this.op_upd()
                                            .then(() => {
/*
                                              _o_this.op_loadDtlAll({b_clr: false})
                                              .then(() => {
                                                cf.myRN_savePageStgs({
                                                  sgc_pageMode: 'show',
                                                })
                                                .then(() => {
                                                  cf.h();
                                                });
                                              });
*/
                                              if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                                const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                                let _ttl = 
                                                  `優先エントリーのキャンセルを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                                let _msg = 
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記優先エントリーのキャンセルを受け付けましたので、ご連絡致します。

<<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${_o_this.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
                                                const _l_tos = [];
                                                if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                                if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                                if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                                const _l_bccs = [ic.g_mail];
                                                if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                                cf.myCB_call_eml(
                                                  _l_tos,
                                                  _ttl,
                                                  _msg,
                                                  _l_bccs
                                                )
                                                .then(() => {
                                                  _o_this.op_loadDtlAll({b_clr: false})
                                                  .then(() => {
                                                    cf.myRN_savePageStgs({
                                                      sgc_pageMode: 'show',
                                                    })
                                                    .then(() => {
                                                      cf.h();
                                                    });
                                                  });
                                                });
                                              }
                                              else {
                                                _o_this.op_loadDtlAll({b_clr: false})
                                                .then(() => {
                                                  cf.myRN_savePageStgs({
                                                    sgc_pageMode: 'show',
                                                  })
                                                  .then(() => {
                                                    cf.h();
                                                  });
                                                });
                                              };
                                            });
                                          })
                                        },
                                      },
                                      {
                                        pfx: 'いいえ',
                                        o_onPrs: () => {
                                        },
                                      }
                                    ]
                                  });
                                }
                            })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1a' && 
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs11i == 20
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'この予約を削除',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(14),
                                backgroundColor: ic.g_ccdHN,
                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                  () => {
/*
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'この予約を削除して宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.myRN_chgPageMode({
                                              mode: 'dlt',
                                            });
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
*/
                                    cf.myRN_chgPageMode({
                                      mode: 'dlt',
                                      msg: 'この予約を削除して宜しいですか？',
                                    });
                                  },
                            })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1b' && 
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs21i == 20
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'このエントリーを削除',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(14),
                                backgroundColor: ic.g_ccdHN,
                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                  () => {
/*
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'このエントリーを削除して宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.myRN_chgPageMode({
                                              mode: 'dlt',
                                            });
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
*/
                                    cf.myRN_chgPageMode({
                                      mode: 'dlt',
                                      msg: 'このエントリーを削除して宜しいですか？',
                                    });
                                  },
                            })
                          : null,

                          (
                            _o_this.d_viewDefs.class == 'i1zv1c' && 
                            ff.f(_o_this.state.sdld_i1zrDtlsss?.i1zr) && 
                            _o_this.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zrs22i == 20
                          ) ?
                            ce.c(ce.Btn, {
                              key: -3,
                              pfx: 'この優先エントリーを削除',
                              stlCta: {
                                marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                              },
                              stlBtn: {
                                width: ic.s(14),
                                backgroundColor: ic.g_ccdHN,
                                borderColor: ic.g_ccdHN,
                              },
                              o_onPrs: 
                                  () => {
/*
                                    cf.myRN_showMdl({
                                      mdl: 'cfm',
                                      msg: 'この優先エントリーを削除して宜しいですか？',
                                      ld_btnss: [
                                        {
                                          pfx: 'はい',
                                          o_onPrs: () => {
                                            cf.myRN_chgPageMode({
                                              mode: 'dlt',
                                            });
                                          },
                                        },
                                        {
                                          pfx: 'いいえ',
                                          o_onPrs: () => {
                                          },
                                        }
                                      ]
                                    });
*/
                                    cf.myRN_chgPageMode({
                                      mode: 'dlt',
                                      msg: 'この優先エントリーを削除して宜しいですか？',
                                    });
                                  },
                            })
                          : null,

                        ])
                      : null,

                      bf.i(_o_this.state.sgc_pageMode, ['new']) ?
                        ce.c(ce.Box, {
                          key: -160,
                          stlCta: {
                            minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: ic.gn_bdyW - ic.m(2),
                            marginTop: ic.s(0.5), // 20211202
                            marginBottom: ic.s(0.5), // 20211202
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }
                        }, [

                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '前の画面に戻る',
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPageMode({
                                mode: 'cclNew',
                              });
                            },
                          }),

                          ( _o_this.d_viewDefs.class == 'i1zv1a') ? 
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この予約を新規登録',
                            stlBtn: {
                              width: ic.s(12),
                            },
                            o_onPrs: () => {
//ff.l('I1zv1 2710: {}'.f(global.t?._b_nowChgI1zrb31f));
//ff.l('I1zv1 2713: {}'.f(_b_endNew));
                              if (_b_endNew == false) {
                                _b_endNew = true;
                                _o_this.$opb_chk()
                                .then( _b_res => {
                                  if (_b_res) {

                                    cf.myRN_chgPageMode({
                                      mode: 'endNew',
                                    })
                                    .then(() => {
                                      _b_endNew = false;
                                      if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                        const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                        let _ttl = 
                                          `ご予約を受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                        let _msg = 
  `団体番号：${_d_i1zrs.d_flds.c30rc11s}
  ${_d_i1zrs.d_flds.c30rc31s}　様
  -------------------------------------------------
  ご利用いただきまして誠にありがとうございます。
  下記ご予約を受け付けましたので、ご連絡致します。
  なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

  <<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

  ■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
  ■部屋：　${_d_i1zrs.d_flds.i10rc31s}
  ■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._01050100}

  ※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._00050100}
  -------------------------------------------------
  `;
                                        const _l_tos = [];
                                        if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                        const _l_bccs = [ic.g_mail];
                                        if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                        //ff.l('I1zv1 2738: {} / {} / {} / {}'.f(_l_tos, _ttl, _msg, _l_bccs));
                                        cf.myCB_call_eml(
                                          _l_tos,
                                          _ttl,
                                          _msg,
                                          _l_bccs
                                        )
                                      }
                                    });
                                  }
                                  else {
                                    _b_endNew = false;
                                  };
                                })
                              }
                            },
                          })
                          : null,


                          ( _o_this.d_viewDefs.class == 'i1zv1b') ? 
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'このエントリーを新規登録',
                            stlBtn: {
                              width: ic.s(14),
                            },
                            o_onPrs: () => {
                              if (_b_endNew == false) {
                                _b_endNew = true;
                                _o_this.$opb_chk()
                                .then( _b_res => {
                                  if (_b_res) {
                                    cf.myRN_chgPageMode({
                                      mode: 'endNew',
                                    })
                                    .then(() => {
                                      _b_endNew = false;
                                      if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                        const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                        let _ttl = 
                                          `エントリーを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                        let _msg = 
  `団体番号：${_d_i1zrs.d_flds.c30rc11s}
  ${_d_i1zrs.d_flds.c30rc31s}　様
  -------------------------------------------------
  ご利用いただきまして誠にありがとうございます。
  下記エントリーを受け付けましたので、ご連絡致します。
  なお、本エントリーを変更する場合は、キャンセルした後、改めてエントリーください。

  <<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

  ■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
  ■部屋：　${_d_i1zrs.d_flds.i10rc31s}
  ■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._02030100}

  ※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._00050100}
  -------------------------------------------------
  `;
                                        const _l_tos = [];
                                        if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                        const _l_bccs = [ic.g_mail];
                                        if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                        cf.myCB_call_eml(
                                          _l_tos,
                                          _ttl,
                                          _msg,
                                          _l_bccs
                                        )
                                      }
                                    });
                                  }
                                  else {
                                    _b_endNew = false;
                                  };
                                });
                              };
                            },
                          })
                          : null,

                          ( _o_this.d_viewDefs.class == 'i1zv1c') ? 
                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この優先エントリーを新規登録',
                            stlBtn: {
                              width: ic.s(16),
                            },
                            o_onPrs: () => {
                              if (_b_endNew == false) {
                                _b_endNew = true;
                                _o_this.$opb_chk()
                                .then( _b_res => {
                                  if (_b_res) {
                                    cf.myRN_chgPageMode({
                                      mode: 'endNew',
                                    })
                                    .then(() => {
                                      _b_endNew = false;
                                      if ( ff.n(_o_this.state.sgcd_stgs._00050310) == 10 ) {
                                        const _d_i1zrs = _o_this.state.sdld_i1zrDtlsss.i1zr[0];
                                        let _ttl = 
                                          `優先エントリーを受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${_o_this.state.sgcd_cmnStgs?.c20r_pfx})`;
                                        let _msg = 
  `団体番号：${_d_i1zrs.d_flds.c30rc11s}
  ${_d_i1zrs.d_flds.c30rc31s}　様
  -------------------------------------------------
  ご利用いただきまして誠にありがとうございます。
  下記優先エントリーを受け付けましたので、ご連絡致します。
  なお、本優先エントリーを変更する場合は、キャンセルした後、改めて優先エントリーください。

  <<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

  ■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
  ■部屋：　${_d_i1zrs.d_flds.i10rc31s}
  ■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._06030100}

  ※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
  -------------------------------------------------
  ${_o_this.state.sgcd_stgs._00050100}
  -------------------------------------------------
  `;
                                        const _l_tos = [];
                                        if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                        if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                        const _l_bccs = [ic.g_mail];
                                        if (ff.f(_o_this.state.sgcd_stgs._00050200)) _l_bccs.push(_o_this.state.sgcd_stgs._00050200);                                  
                                        cf.myCB_call_eml(
                                          _l_tos,
                                          _ttl,
                                          _msg,
                                          _l_bccs
                                        )
                                      }
                                    });
                                  }
                                  else {
                                    _b_endNew = false;
                                  };
                                })
                              };
                            },
                          })
                          : null,

                        ])
                      : null,

                      bf.i(_o_this.state.sgc_pageMode, ['edit']) ?
                        ce.c(ce.Box, {
                          key: -170,
                          stlCta: {
                            minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            width: ic.gn_bdyW - ic.m(2),
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }
                        }, [

                          ce.c(ce.Btn, {
                            key: -1,
                            pfx: '変更を止める',
                            stlCta: {
                              marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                            },
                            stlBtn: {
                              width: ic.s(8),
                              backgroundColor: ic.g_ccdHN,
                              borderColor: ic.g_ccdHN,
                            },
                            o_onPrs: () => {
                              cf.myRN_chgPageMode({
                                mode: 'cclEdit',
                              });
                            },
                          }),

                          ce.c(ce.Btn, {
                            key: -2,
                            pfx: 'この情報を登録',
                            stlCta: {
                              marginTop: (ic.g_dvcMode == 's') ? ic.s(0.5) : null // 20211202
                            },
                            stlBtn: {
                              width: ic.s(8),
                            },
                            o_onPrs: () => {
//ff.l('i1zv1 2986: here')
                              _o_this.$opb_chk()
                              .then( _b_res => {
//ff.l('i1zv1 2989: {}'.f(_b_res))
                                if (_b_res) {
                                  cf.myRN_chgPageMode({
                                    mode: 'endEdit',
                                  });
                                };
                              })
                            },
                          }),

                        ])
                      : null,

                    ]),

                  ],
                },
              }),

            ],
          }
        }

      : {}
    )
  );
}

}
